import React, { useState, useEffect } from 'react';
import { useLeagues, useTopScorers } from '../hooks/useFootball';
import LeagueSelector from '../components/football/LeagueSelector';
import TopScorersTable from '../components/football/TopScorersTable';
import ErrorMessage from '../components/common/ErrorMessage';

const TopScorersPage = () => {
  const { leagues, loading: leaguesLoading, error: leaguesError } = useLeagues();
  const [selectedLeague, setSelectedLeague] = useState(null);
  const { topScorers, loading: scorersLoading, error: scorersError, refetch } = useTopScorers(selectedLeague);

  // İlk lig yüklendiğinde varsayılan lig seç (Süper Lig veya ilk lig)
  useEffect(() => {
    if (leagues.length > 0 && !selectedLeague) {
      const superLig = leagues.find(l => l.key === 'super-lig');
      setSelectedLeague(superLig ? superLig.key : leagues[0].key);
    }
  }, [leagues, selectedLeague]);

  const selectedLeagueTitle = leagues.find(l => l.key === selectedLeague)?.title || 'Gol Kralları';

  if (leaguesError) {
    return (
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <ErrorMessage message={leaguesError} onRetry={() => window.location.reload()} />
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      {/* Page Header */}
      <header className="mb-8">
        <div className="flex items-center space-x-3 mb-2">
          <div className="w-1.5 h-10 rounded-full bg-yellow-500"></div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
            Gol Kralları
          </h1>
        </div>
        <p className="text-gray-600 dark:text-gray-400 ml-5">
          Liglerin en golcü oyuncularını takip edin
        </p>
      </header>

      {/* League Selector */}
      <section className="mb-6">
        <LeagueSelector
          leagues={leagues}
          selectedLeague={selectedLeague}
          onSelect={setSelectedLeague}
          loading={leaguesLoading}
        />
      </section>

      {/* Selected League Title */}
      {selectedLeague && (
        <div className="mb-4 flex items-center justify-between">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white flex items-center">
            <svg className="w-6 h-6 mr-2 text-yellow-500" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M5 2a1 1 0 011 1v1h1a1 1 0 010 2H6v1a1 1 0 01-2 0V6H3a1 1 0 010-2h1V3a1 1 0 011-1zm0 10a1 1 0 011 1v1h1a1 1 0 110 2H6v1a1 1 0 11-2 0v-1H3a1 1 0 110-2h1v-1a1 1 0 011-1zM12 2a1 1 0 01.967.744L14.146 7.2 17.5 9.134a1 1 0 010 1.732l-3.354 1.935-1.18 4.455a1 1 0 01-1.933 0L9.854 12.8 6.5 10.866a1 1 0 010-1.732l3.354-1.935 1.18-4.455A1 1 0 0112 2z" clipRule="evenodd" />
            </svg>
            {selectedLeagueTitle}
          </h2>
          <button
            onClick={refetch}
            className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
            title="Yenile"
          >
            <svg className={`w-5 h-5 text-gray-500 ${scorersLoading ? 'animate-spin' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
          </button>
        </div>
      )}

      {/* Top Scorers Table */}
      {scorersError ? (
        <ErrorMessage message={scorersError} onRetry={refetch} />
      ) : (
        <TopScorersTable topScorers={topScorers} loading={scorersLoading} />
      )}
    </div>
  );
};

export default TopScorersPage;
